import React, { useEffect, useState } from "react";
import "../../assets/css/tables.css";
import Swal from "sweetalert2";
import deletes from "../../assets/images/tablesImg/delete.png";
import edit from "../../assets/images/tablesImg/edit.png";
import testBluePng from "../../assets/images/notes/notes.svg";
import more_vert from "../../assets/images/home/more_vert.png";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import Repository from "../../configs/axios/repository";
import { handleGetFlashcard } from "../../redux/layout";
import { handleGetTikets } from "../../redux/layout";
import {
    UncontrolledDropdown,
    DropdownMenu,
    DropdownToggle,
    DropdownItem,
} from "reactstrap";
import { useSelector } from "react-redux";
import { openFlashcard } from "../globalFunctions/openFlashcard";
import { openTest } from "../globalFunctions/openTest";
const NotesTable = ({
    notes,
    refreshTable,
    loadingData,
    course_id,
    canDoIt,
    courseName,
    fromCourse,
}) => {
    const [showCources, setShowCources] = useState(true);
    const isInvateValue = useSelector((state) => state.layout.isInvate);
    const role = useSelector((state) => state.layout.role);
    const [isCourseNote, setIsCourseNote] = useState(false);

    const currentPathname = window.location.pathname;
    const history = useHistory();
    const dispatch = useDispatch();
    const deleteNote = async (id) => {
        const result = await Repository.deleteById(
            `api/notes/makeDeleted/${id}`
        );
        if (result.data?.success == true) {
            refreshTable();
            loadingData
                ? Swal.fire(
                      "Deleted!",
                      "Your file has been deleted.",
                      "success"
                  )
                : "";
        }
    };
    function handleDelete(id) {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                deleteNote(id);
            }
        });
    }

    const getNoteById = async (file, type) => {
        let note_id = {
            note_id: file.note_id,
        };
        let testType = type;

        let notes = file.summary ? file.summary : file.notes;
        let noteData = {
            title: file.title,
            description: file.description,
            summary: file.summary,
        };
        
        if (type == "flashcard") {
            const resultForFlashcard = await Repository.findByEndPoint(
                `api/notes/findNotesById/${file.note_id}`
            );

            if (
                resultForFlashcard.status === 200 ||
                resultForFlashcard.status === 201
            ) {
                if (resultForFlashcard.data.data.flashcard.length >= 1) {
                    
                    localStorage.setItem("note_id", file.note_id);
                    openFlashcard(
                        dispatch,
                        history,
                        {
                            ...resultForFlashcard.data.data.flashcard[0],
                            note_id,
                        },
                        handleGetFlashcard,
                        noteData,
                        canDoIt,
                        notes
                    );
                } else {
                    history.push({
                        pathname: "/flashcards",
                        state: {
                            note_id,
                            notes,
                            noteData,
                            canDoIt,
                        },
                    });
                }
            }
        }
        if (type == "choice" || type == "written") {
            const resultForTests = await Repository.findByEndPoint(
                `api/notes/findNoteTestsById/${Number(
                    file.note_id
                )}?test_type=${type}`
            );

            if (
                resultForTests.data.data?.test_note.length >= 1 &&
                role == "student"
            ) {
                openTest(
                    dispatch,
                    history,
                    {
                        ...resultForTests.data.data.test_note[0],
                        note_id,
                    },
                    handleGetTikets,
                    noteData,
                    canDoIt,
                    fromCourse,
                    notes
                );
            } else {
                note_id = file.note_id;
                history.push({
                    pathname: "/tests",
                    state: {
                        note_id,
                        notes,
                        testType,
                        noteData,
                        canDoIt,
                        courseName,
                        course_id,
                    },
                });
            }
        }
    };

    useEffect(() => {
        setShowCources(isInvateValue);
    }, [isInvateValue]);

    const thumbs = notes?.map((file, i) => {
        return (
            <div key={i} className="notesContent mt-4">
                <div
                    className="parentCoursesDiv "
                    onClick={(e) => {
                        let note_id = file.note_id;
                        role == "instructor" || currentPathname == "/home"
                            ? history.push({
                                  pathname: "/note",
                                  state: { note_id },
                              })
                            : "";
                    }}
                >
                    <div className="clidrenDivCompakt">
                        <div>
                            <img src={testBluePng} alt="testPng" />
                        </div>
                        <div>
                            <div className="mt-3">
                                <span>{file.title}</span>
                                <p>{file.description}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className=" notesFildsParrent">
                    <div className="notesFilds">
                        {role == "instructor" || currentPathname == "/home" ? (
                            <button
                                className=" viewNote"
                                onClick={(e) => {
                                    let note_id = file.note_id;
                                    history.push({
                                        pathname: "/note",
                                        state: { note_id },
                                    });
                                }}
                            >
                                VIEW NOTE
                            </button>
                        ) : (
                            ""
                        )}
                        {role == "instructor" || canDoIt == false ? (
                            ""
                        ) : (
                            <button
                                className="flashButton"
                                onClick={() => {
                                    getNoteById(file, "flashcard");
                                }}
                            >
                                Flashcards
                            </button>
                        )}

                        <button
                            className="flashButton"
                            onClick={() => {
                                getNoteById(file, "choice");
                            }}
                        >
                            Multiple Choice
                        </button>
                        {/* )} */}

                        <button
                            className="flashButton"
                            onClick={() => {
                                getNoteById(file, "written");
                            }}
                        >
                            Written
                        </button>
                    </div>

                    {role == "instructor" || currentPathname == "/home" ? (
                        <div className="parentDeleteNote">
                            <UncontrolledDropdown className="dropdown-user nav-item ">
                                <DropdownToggle
                                    tag="a"
                                    className="nav-link dropdown-user-link "
                                >
                                    <img
                                        src={more_vert}
                                        alt="points"
                                        className="pointImg "
                                    />
                                </DropdownToggle>
                                <DropdownMenu end>
                                    <DropdownItem
                                        onClick={(e) => {
                                            handleDelete(file.note_id);
                                        }}
                                    >
                                        <div className="actionsMenu actionsMenuContent">
                                            <img src={deletes} alt="deletes" />
                                            <span>Delete</span>
                                        </div>
                                    </DropdownItem>

                                    <DropdownItem
                                        onClick={(e) => {
                                            let note_id = file.note_id;
                                            history.push({
                                                pathname: "/note",
                                                state: {
                                                    note_id,
                                                    course_id,
                                                    courseName,
                                                },
                                            });
                                        }}
                                    >
                                        <div className="actionsMenu actionsMenuContent">
                                            <img src={edit} alt="deletes" />
                                            <span>Edit</span>
                                        </div>
                                    </DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </div>
                    ) : (
                        ""
                    )}
                </div>
            </div>
        );
    });

    return <div className="divTable"> {thumbs} </div>;
};

export default NotesTable;
